// Generated by script, don't edit it please.
import createSvgIcon from '../../createSvgIcon';
import AttachmentSvg from '@rsuite/icon-font/lib/legacy/Attachment';
var Attachment = createSvgIcon({
    as: AttachmentSvg,
    ariaLabel: 'attachment',
    category: 'legacy',
    displayName: 'Attachment'
});
export default Attachment;
